import { render, staticRenderFns } from "./OceanShipping.vue?vue&type=template&id=77be4100&"
import script from "./OceanShipping.vue?vue&type=script&lang=js&"
export * from "./OceanShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports